<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading ml-1">
            Pending Invites into
            <span class="font-weight-bold">
              {{ $store.getters.getCurrentOrgName }}
            </span>
          </h4>
          <v-spacer></v-spacer>
          <v-flex text-xs-right>
            <v-btn
              icon
              @click.stop="loadPendingList()"
              :disabled="invitesLoadingFlag"
            >
              <v-icon title="Refresh" color="#d13b55">mdi-refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-list dense two-line class="rounded list-bg">
            <div class="pa-2 rounded white-bg mb-2" v-if="invitesLoadingFlag">
              <v-progress-linear
                color="#d13b55"
                height="2"
                :indeterminate="true"
              ></v-progress-linear>
            </div>

            <div
              v-if="orgInvites.length == 0 && !invitesLoadingFlag"
              class="pa-2 rounded white-bg"
            >
              <span>You do not have any unfulfilled invites.</span>
            </div>

            <div v-else v-for="(orgInvite, index) in orgInvites" :key="index">
              <v-list-tile avatar ripple class="rounded list-tile-bg">
                <v-list-tile-avatar>
                  <v-icon size="40">mdi-account-outline</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    ><strong>{{ orgInvite.name }}</strong></v-list-tile-title
                  >
                  <v-list-tile-sub-title>{{
                    orgInvite.email
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="orgInvite.sentDate">
                  <p class="mt-3">
                    <strong>Last Sent:</strong>
                    {{
                      orgInvite.sentDate | moment("dddd, MMMM DD, YYYY, h:mm a")
                    }}
                  </p>
                </v-list-tile-action>

                <v-list-tile-action
                  v-if="
                    $store.getters.userIsAdministrativeOrOrgOwner &&
                    !orgInvite.isAccepted
                  "
                >
                  <v-btn
                    title="Click to invite again"
                    icon
                    @click.stop="reInvite(orgInvite)"
                  >
                    <v-icon color="primary">mdi-email-plus-outline</v-icon>
                  </v-btn>
                </v-list-tile-action>

                <v-list-tile-action
                  v-if="$store.getters.userIsAdministrativeOrOrgOwner"
                >
                  <v-btn
                    title="Remove Invite From Organization"
                    icon
                    @click.stop="
                      inviteToRemoveFromOrg = orgInvite.email;
                      confirmDeleteDialog = true;
                    "
                  >
                    <v-icon color="error">mdi-minus-circle</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < orgInvites.length"
                :key="index + 1 + orgInvites.length"
              ></v-divider>
            </div>
          </v-list>
          <!-- <div class="mt-3" v-if="$store.getters.userIsAdministrativeOrOrgOwner">
            <v-btn color="primary" to="/invite">Send an Invite</v-btn>
          </div>-->
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="confirmDeleteDialog" overlay persistent max-width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Remove Invite from Organization</v-card-title
        >
        <v-card-text
          >Are you sure you want to remove this invite from the current
          Organization?</v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="btn-rounded-medium"
            color="secondary"
            outline
            @click="confirmDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-rounded-medium"
            color="red lighten-2"
            outline
            @click="
              removeInviteFromOrg();
              confirmDeleteDialog = false;
            "
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "PendingInvitesListComponent",
  data() {
    return {
      orgInvites: [],
      confirmDeleteDialog: false,
      inviteToRemoveFromOrg: null,
      invitesLoadingFlag: true,
    };
  },
  computed: {},
  methods: {
    loadPendingList: function () {
      this.invitesLoadingFlag = true;
      axios
        .get("/api/org/member/pending", this.$store.state.axiosConfig)
        .then((response) => {
          this.orgInvites = response.data;
          this.$store.state.pendingInvitesCount =
            this.orgInvites.length +
            ((this.$store.state.userSelf || {}).pendingInvites || []).length;
          this.invitesLoadingFlag = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization pending invites list NOT retrieved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.invitesLoadingFlag = false;
        });
    },
    removeInviteFromOrg: function () {
      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Removing invite from current Organization...",
        messageType: "warning",
      });

      const params = { email: this.inviteToRemoveFromOrg };
      this.invitesLoadingFlag = true;
      axios
        .post(
          "/api/org/member/pending/remove",
          params,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Successfully Removed the Invite from the Organization.",
          });

          // update the list
          this.orgInvites = response.data.pendingInviteList;
          this.$store.state.pendingInvitesCount =
            this.orgInvites.length +
            ((this.$store.state.userSelf || {}).pendingInvites || []).length;
          this.invitesLoadingFlag = false;
        })
        .catch((e) => {
          // check/handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Pending invite was NOT removed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.invitesLoadingFlag = false;
        });
    },
    reInvite: function (inviteModel) {
      this.invitesLoadingFlag = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Inviting " + inviteModel.email,
        messageType: "warning",
      });

      const params = {
        subdomain: inviteModel.subdomain,
        email: inviteModel.email,
        invitedBy:
          this.$store.state.userSelf.profile.firstname +
          " " +
          this.$store.state.userSelf.profile.lastname,
      };

      axios
        .post("/api/org/reinvite", params, this.$store.state.axiosConfig)
        .then((response) => {
          this.loadPendingList();
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Successfully sent invite to " + inviteModel.email,
          });

          this.invitesLoadingFlag = false;
        })
        .catch((e) => {
          // check/handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Invite was NOT send to " +
              inviteModel.email +
              ".<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.invitesLoadingFlag = false;
        });
    },
  },
  beforeMount() {
    this.loadPendingList();
  },
};
</script>
